// @flow
import React from 'react';
import MarkdownRender from 'components/common/MarkdownRender';
import './BrandContent.scss';

type Props = {
  body: string,
  theme: string,
  thumbnail: ?string,
  onSetToc: (toc: any) => void,
  onActivateHeading: (headingId: string) => void,
};

const BrandContent = ({ body, onSetToc, onActivateHeading, thumbnail, theme }: Props) => (
  <div className="BrandContent">
    <div className="brand-info">
      {thumbnail && (
        <div className="brand-thumbnail">
          <img src={thumbnail} alt="brand-thumbnail" />
        </div>
      )}
    </div>
    <div className="contents">
      <MarkdownRender
        body={body}
        onSetToc={onSetToc}
        onActivateHeading={onActivateHeading}
        theme={theme || 'github'}
      />
    </div>
  </div>
);

BrandContent.Placeholder = () => (
  <div className="BrandContent placeholder">
    <div className="brand-thumbnail">
      <div className="fake-img" />
    </div>
    <div className="contents">
      <div className="gray-block" />
      <div className="gray-block" />
      <div className="gray-block" style={{ width: '75%' }} />
      <div className="line-breaker" />
      <div className="gray-block" />
      <div className="gray-block" style={{ width: '40%' }} />
      <div className="line-breaker" />
      <div className="gray-block" />
      <div className="gray-block" />
      <div className="gray-block" />
      <div className="gray-block" style={{ width: '40%' }} />
    </div>
  </div>
);

export default BrandContent;



// WEBPACK FOOTER //
// ./src/components/brand/BrandContent/BrandContent.js